module.exports = {"320904001":"丰华街道","320904002":"大中街道","320904101":"草堰镇","320904102":"白驹镇","320904103":"刘庄镇","320904104":"西团镇","320904105":"小海镇","320904106":"大桥镇","320904107":"草庙镇","320904108":"万盈镇","320904109":"南阳镇","320904110":"新丰镇","320904111":"三龙镇","320904400":"大中农场","320904401":"方强农场","320904402":"东坝头农场","320904403":"大丰经济开发区管委会","320904404":"大丰港经济开发区管委会","320904405":"大丰常州高新区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320904.json
// module id = 906
// module chunks = 0